var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DeleteDialog',{attrs:{"dialog":_vm.dialog,"entityTitle":_vm.entityTile}})
}
var staticRenderFns = []

export { render, staticRenderFns }